import {WebviewApiError} from "./WebviewApiError";

const funcCounters = {};

export function createFuncHandler(context, name) {
  funcCounters[name] = funcCounters[name] || 0;

  const funcName = `rf_${name}_${funcCounters[name]++}`;
  const funcObj = {
    name: funcName,
    delete: function() {
      delete window[this.name];
    },
  };

  funcObj.promise = new Promise((resolve, reject) => {
    Object.defineProperty(window, funcName, {
      value: function(data) {
        console.log(`[webview-api] [response] ${funcName}: ${typeof data === "string" ? data : JSON.stringify(data)}`);

        let d;
        try {
          d = parseResponseData(data);
        } catch (err) {
          reject(err);
        }

        resolve(d);
        funcObj.delete();
      },
      enumerable: true,
      configurable: true,
      writable: true,
    });
  });

  return funcObj;
}

export function legacyCall(context, functionName, params) {
  const url = buildLegacyCallURL(functionName, params);

  console.log(`[webview-api] [call legacy] ${url}`);

  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.src = url;
  document.documentElement.appendChild(iframe);
  setTimeout(() => document.documentElement.removeChild(iframe), 0);
}

export function buildLegacyCallURL(functionName, params) {
  const queryPairs = [];

  params && Object.keys(params).forEach((key) => {
    if (typeof params[key] !== "undefined") {
      queryPairs.push(`${key}=${params[key]}`);
    }
  });

  return `callback:${functionName}${queryPairs.length > 0 ? "?" : ""}${queryPairs.join("&")}`;
}

export function defaultCall(context, funcName, params, options, data) {
  options = Object.assign({
    legacy: true,
    native: true,
    ignoreSyncResponse: false,
  }, options);

  if (options.native) {
    const serializedParams = JSON.stringify(params);

    if (context.nativeAndroidApi && typeof context.nativeAndroidApi[funcName] === "function") {
      console.log(`[webview-api] [call native] ${funcName}: ${serializedParams}`);
      let response;

      try {
        if (typeof data !== "undefined") {
          response = context.nativeAndroidApi[funcName](serializedParams, data);
        } else {
          response = context.nativeAndroidApi[funcName](serializedParams);
        }
      } catch (err) {
        console.error(`[webview-api] native call failed: ${funcName}`, err);
        throw err;
      }

      if (typeof response !== "undefined" && !options.ignoreSyncResponse) {
        console.log(`[webview-api] [response sync] ${funcName}: ${response}`);
        return parseResponseData(response);
      }

      return;
    }

    if (context.nativeIosApi) {
      console.log(`[webview-api] [call native] ${funcName}: ${serializedParams}`);

      try {
        context.nativeIosApi.postMessage({action: funcName, json: params});
      } catch (err) {
        console.error(`[webview-api] native call failed: ${funcName}`, err);
        throw err;
      }
      return;
    }
  }

  if (options.legacy) {
    if (typeof params["web_extra"] === "object") {
      params["web_extra"] = encodeURIComponent(JSON.stringify(params["web_extra"]));
    }

    legacyCall(context, funcName, params);
    return;
  }

  console.log(`[webview-api] no api to call ${funcName}`);
}

export function parseResponseData(data) {
  if (typeof data === "string" && data.length > 0 && (data[0] === "{" || data[0] === "[")) {
    return JSON.parse(data);
  } else {
    return data;
  }
}

export function isAppBuild(context, builds) {
  if (context.platform === "unrecognized") {
    return false;
  }

  for (const build of builds) {
    if (build.appId === context.appId) {
      return typeof build[context.platform] === "number"
        && context.versionCode >= build[context.platform];
    }
  }

  return false;
}

export function isWebApiVersion(context, versions) {
  if (context.platform === "unrecognized") {
    return false;
  }

  return typeof versions[context.platform] === "number"
    && context.webApiVersion >= versions[context.platform];
}

export function checkWebviewResponse(response, cb = (res) => res) {
  if (typeof response === "object" && response !== null) {
    if (typeof response.error === "object" && response.error !== null) {
      return {
        ok: false,
        error: new WebviewApiError(response.error.code, response.error.message || ""),
        extra: response.web_extra,
      };
    }
  }

  return {
    ok: true,
    result: cb(response),
    extra: response?.web_extra,
  };
}
